import angular from 'angular';
import { debounce, forEach, indexOf, reduce, uniq } from 'lodash';

module.exports = angular.module('common.directives.table-frozen', [])
.directive('tableFrozen', function($window) {
  function TableCtrl() {
    this.elements = [];
    this.freezeLater = debounce(this.freeze);
  }

  TableCtrl.prototype.add = function(elem) {
    this.elements.push(elem);
    this.unfreeze();
    this.freezeLater();
  };

  TableCtrl.prototype.unfreeze = function() {
    forEach(this.elements, function(elem) {
      if (elem.hasClass('col-frozen-last')) {
        elem.next().css('padding-left', null);
      }

      elem.css({ position: null, width: null });
      elem.removeClass('col-frozen-last');
    });
  };

  TableCtrl.prototype.freeze = function() {
    this.unfreeze();

    var rows = [];
    var columns = [];

    forEach(this.elements, function(elem) {
      var tr = elem.parent(),
          i = indexOf(tr.children(), elem[0]);

      rows.push(tr);
      (columns[i] = columns[i] || []).push(elem);
    });

    forEach(uniq(rows), function(row) {
      var height = { height: row.prop('offsetHeight') + 'px' };
      row.css(height);

      forEach(row.children(), function(elem) {
        elem = angular.element(elem);
        if (elem.hasClass('col-frozen')) {
          elem.css(height);
        }
      });
    });

    var left = 0;
    forEach(columns, function(elems) {
      elems.width = reduce(elems, function(maxWidth, elem) {
        var width = elem.prop('offsetWidth');
        return Math.max(width, maxWidth);
      }, 0);

      elems.left = left;
      left += elems.width;

      forEach(elems, function(elem) {
        elem.css({ position: 'absolute', width: elems.width + 'px' });

        var next = elem.next();
        if (next.hasClass('col-frozen')) {
          next.css('left', elems.left + elems.width + 'px');
        } else {
          var padding = parseInt($window.getComputedStyle(next[0]).paddingLeft);
          next.css('padding-left', padding + elems.left + elems.width + 'px');
          elem.addClass('col-frozen-last');
        }
      });
    });
  };

  return {
    restrict: 'AC',
    controller: TableCtrl
  };
})
.directive('colFrozen', function() {
  return {
    restrict: 'AC',
    require: '^tableFrozen',
    link: function(scope, elem, attrs, tableCtrl) {
      scope.$evalAsync(function() { tableCtrl.add(elem); });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/table-frozen.js
 **/